import React from 'react';
import Icon from '../../../components/AppIcon';

const RouteHero = ({ route, onBookNow }) => {
  return (
    <div className="relative bg-gradient-journey text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1200')] bg-cover bg-center" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
              <Icon name="TrendingUp" size={16} />
              <span className="text-sm font-medium">Popular Route</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold leading-tight">
              {route?.from} to {route?.to}
            </h1>
            
            <p className="text-base md:text-lg text-white/90 leading-relaxed max-w-xl">
              Experience comfortable and reliable travel between {route?.from} and {route?.to}. Professional drivers, well-maintained vehicles, and 24/7 support for your journey.
            </p>
            
            <div className="flex flex-wrap items-center gap-4 md:gap-6 pt-2">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Icon name="MapPin" size={20} className="text-accent" />
                </div>
                <div>
                  <p className="text-xs text-white/70">Distance</p>
                  <p className="text-sm md:text-base font-semibold">{route?.distance}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Icon name="Clock" size={20} className="text-accent" />
                </div>
                <div>
                  <p className="text-xs text-white/70">Duration</p>
                  <p className="text-sm md:text-base font-semibold">{route?.duration}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-white/10 backdrop-blur-sm flex items-center justify-center">
                  <Icon name="Star" size={20} className="text-accent" />
                </div>
                <div>
                  <p className="text-xs text-white/70">Rating</p>
                  <p className="text-sm md:text-base font-semibold">{route?.rating} / 5.0</p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-3 pt-4">
              <button
                onClick={onBookNow}
                className="px-6 md:px-8 py-3 md:py-4 bg-action hover:bg-action/90 text-white rounded-lg font-semibold text-sm md:text-base transition-all duration-200 hover:scale-105 flex items-center justify-center gap-2"
              >
                <Icon name="Calendar" size={20} />
                Book This Route Now
              </button>
              
              <button
                onClick={() => window.open('https://wa.me/917998666660', '_blank')}
                className="px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white rounded-lg font-semibold text-sm md:text-base transition-all duration-200 flex items-center justify-center gap-2 whatsapp-pulse"
              >
                <Icon name="MessageCircle" size={20} />
                WhatsApp Inquiry
              </button>
            </div>
          </div>
          
          <div className="hidden lg:block">
            <div className="relative">
              <div className="absolute inset-0 bg-accent/20 rounded-2xl blur-3xl" />
              <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-6 space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-white/70">Starting from</span>
                  <div className="flex items-center gap-1">
                    <Icon name="TrendingDown" size={16} className="text-accent" />
                    <span className="text-xs text-accent font-medium">Best Price</span>
                  </div>
                </div>
                <div className="text-4xl font-bold">₹{route?.startingPrice?.toLocaleString('en-IN')}</div>
                <div className="flex items-center gap-2 text-sm text-white/80">
                  <Icon name="CheckCircle" size={16} className="text-accent" />
                  <span>Includes tolls & taxes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RouteHero;